import styled from 'styled-components';
import { BigButton } from '../../../../components/BigButton';

export const PaymentContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    gap: .75rem;
`;

interface PaymentButtonProps {
    bgColor: 'disabled' | 'pix' | 'card';
    color: 'black' | 'white';
}

export const PaymentButton = styled(BigButton)<PaymentButtonProps>`
    background-color: ${({ bgColor, theme }) => {
        if (bgColor === 'pix') {
            return '#32BCAD';
        } else if (bgColor === 'card') {
            return theme.colors['supernova-500'];
        }
        return theme.colors['neutral-0'];
    }};

    border-radius: 0.75rem;
    outline: ${({ bgColor, theme }) => {
        if (bgColor === 'pix') {
            return 'none';
        } else if (bgColor === 'card') {
            return 'none';
        }
        return `2px solid ${theme.colors['silver-100']}`;
    }};
    color: ${({ color }) => color};
    
    .payment-icon {
        width: 24px;
        height: 24px;
    }
`;
